export const demoInsights = [
  {
    lastName: 'Bond',
    notes: null,
    contactInfo: 'website: http://www.adrizer.com',
    linkedinUrl: 'https://www.linkedin.com/in/kenbondjr/',
    postalCode: null,
    source: null,
    linkedin: [
      {
        id: 'kenbondjr',
        type: 'common',
      },
    ],
    firstName: 'Ken',
    createdAt: '2019-11-07T02:36:54.000Z',
    companies: [
      {
        company: {
          keywords: [],
          companyType: 'private',
          lastUpdatedAt: '2022-10-19T12:42:38.731Z',
          postalCode: '34236',
          companySiteData: {
            keywords: [],
          },
          description:
            'AdRizer is a full-service tracking platform for advertisers seeking ROI optimization and digital analytics. Founded by publishers who saw a need to understand the ROI for each piece of content marketed through various partners, AdRizer has proven itself a must-have for publishers looking for the most effective way to market their content to the most valuable audience.\n\nFounded in 2013, AdRizer started on a kitchen counter as a small business. Since then, we’ve built one of the top 100 sites in the USA, partnered with the world’s leading advertising companies, and have developed a propriety analytics and monetization platform for publishers.\n\nIn the fast-paced world of digital marketing, speed, scale, efficiency, and reliability are paramount. AdRizer is able to deliver lightning fast results through our massive, global cloud infrastructure, driven by a suite of powerful applications.\n\nA Note to Applicants:\n\nAt AdRizer, we value dedication over degrees and hard work over everything else. We want rockstars. If you’ve got what we’re looking for, you’re hungry to prove yourself and you’re looking for a company that will let you do just that, then step on up and apply to one of our open careers now.\n\nWe love what we do, and we keep our work fun. As part of the AdRizer family, expect to be part of a team-centric environment where you can improve your ping pong game in between improving ROI.\n',
          industry: 'Internet',
          linkedin: [
            {
              id: 'ad-rizer',
              type: 'common',
            },
            {
              id: '5225743',
              type: 'sales',
            },
          ],
          technologies: [
            '628defc8bdd46f5a39fd68ed',
            '628defc8bdd46f5a39fd6898',
            '628defc8bdd46f5a39fd64a5',
            '628defc8bdd46f5a39fd64e9',
            '628defc8bdd46f5a39fd6337',
            '628defc8bdd46f5a39fd6224',
            '628defc8bdd46f5a39fd6223',
            '628defc8bdd46f5a39fd632d',
            '628defc8bdd46f5a39fd622e',
            '628defc8bdd46f5a39fd622b',
            '628defc8bdd46f5a39fd6218',
            '628defc8bdd46f5a39fd616c',
            '628defc8bdd46f5a39fd6097',
            '628defc8bdd46f5a39fd617a',
          ],
          alternativeNames: [],
          createdAt: '2019-11-07T02:36:54.000Z',
          foundedAt: 2014,
          headquarters: '1570 Boulevard of the Arts Florida Sarasota',
          competitors: [],
          size: 24,
          countryCode: 'US',
          leads: 24,
          domain: 'adrizer.com',
          name: 'AdRizer',
          location: {},
          id: '5f72125bdab6bb429c064b30',
          updatedAt: '2022-10-19T12:42:38.824Z',
        },
        position: 'Co-Founder / CEO',
      },
    ],
    countryCode: 'US',
    location: 'Sarasota, Florida, United States',
    id: '5f76c7807c58001e1a1150fc',
    geolocation: {},
    saved: false,
    name: 'Ken Bond',
  },
  {
    lastName: 'Gizis',
    notes: null,
    contactInfo: 'website: http://www.connectify.me/\nwebsite: http://www.speedify.com/',
    linkedinUrl: 'https://www.linkedin.com/in/alexander-gizis-230a8310/',
    postalCode: null,
    source: null,
    linkedin: [
      {
        id: 'alexander-gizis-230a8310',
        type: 'common',
      },
    ],
    firstName: 'Alexander',
    createdAt: '2020-06-17T13:10:50.000Z',
    companies: [
      {
        company: {
          keywords: [],
          companyType: 'private',
          lastUpdatedAt: '2022-01-30T12:18:51.758Z',
          postalCode: '19102',
          companySiteData: {
            keywords: [],
          },
          description:
            'Better Internet, for everyone.\n\nAt Connectify we make complex networking tasks easy by developing apps that deliver faster, more reliable, and more secure Internet to users all across the globe. Our suite of products empowers users to analyze, share, combine, encrypt, and ultimately unlock the full potential of their Internet connections.\n\nConnectify is located in sunny Philadelphia, PA. \n\nFeel free to contact us directly at sales@connectify.me.',
          industry: 'Internet',
          linkedin: [],
          technologies: [
            '628defc8bdd46f5a39fd6922',
            '628defc8bdd46f5a39fd646b',
            '628defc8bdd46f5a39fd651a',
            '628defc8bdd46f5a39fd6926',
            '628defc8bdd46f5a39fd64a5',
            '628defc8bdd46f5a39fd6218',
          ],
          alternativeNames: [],
          createdAt: '2019-08-13T18:20:14.000Z',
          headquarters: '1429 Walnut Street PA Philadelphia',
          competitors: [],
          size: 24,
          countryCode: 'US',
          leads: 10,
          domain: 'connectify.me',
          name: 'Connectify',
          location: {},
          id: '5f7204af6e3f4d42e23e71ef',
          updatedAt: '2022-06-21T09:07:40.805Z',
        },
        position: 'CEO and co-founder',
      },
    ],
    countryCode: 'us',
    location: 'Philadelphia, Pennsylvania, United States',
    id: '5f76c00ab6715b1dcea3b255',
    geolocation: {},
    saved: false,
    name: 'Alexander Gizis',
  },
  {
    lastName: 'Kardwell',
    notes: null,
    contactInfo: 'website: http://www.constant.com \n',
    linkedinUrl: 'https://www.linkedin.com/in/kardwell/',
    lastUpdatedAt: '2023-01-15T18:27:38.738Z',
    postalCode: null,
    source: null,
    linkedin: [
      {
        id: 'kardwell',
        type: 'common',
      },
      {
        id: 'ACoAAAAjGWUBxPFsD5DV1Soy5sEkdYgLUB5G4x0',
        type: 'sales',
      },
    ],
    firstName: 'J J ',
    createdAt: '2019-08-13T18:36:26.000Z',
    companies: [
      {
        company: {
          totalVisits: 10700,
          keywords: [],
          companyType: 'private',
          lastUpdatedAt: '2023-01-15T18:27:28.036Z',
          postalCode: '33401',
          companySiteData: {
            keywords: [],
          },
          description:
            "Our flagship product, Vultr® is a favorite with the developer community, serving over 1.3 million customers with flexible, scalable, global bare metal, dedicated cloud, and storage solutions.\n\nKnown for supporting today's most critical business applications, we help developers, business leaders, and enterprise brands experience the high performance of bare metal, with the enhanced orchestration of virtual servers.\n\nWe deliver continuous uptime, cost-effective cloud infrastructure, and 24x7 global support to help developers build more, faster, and accessible from any location, worldwide.",
          industry: 'Internet',
          linkedin: [
            {
              id: 'constantllc',
              type: 'common',
            },
            {
              id: '71501562',
              type: 'sales',
            },
          ],
          technologies: [],
          alternativeNames: ['Constant, LLC', 'Constant, LLC', 'Constant', 'Constant', 'Constant'],
          createdAt: '2019-04-03T05:34:08.000Z',
          foundedAt: null,
          headquarters: '319 Clematis St Florida West Palm Beach',
          competitors: [
            {
              company: '5f720def077515428b0ace96',
              affinity: 96,
            },
            {
              company: '5f72f0015caf37425a78b3a6',
              affinity: 83,
            },
            {
              company: '5f720d86077515428b0acd4f',
              affinity: 86,
            },
            {
              company: '5f720d8f502521426f823f5c',
              affinity: 100,
            },
            {
              company: '5f7207225caf37425a6e5c00',
              affinity: 84,
            },
          ],
          revenueRange: {
            from: 15000000,
            to: 25000000,
          },
          size: 79,
          countryCode: 'US',
          leads: 42,
          domain: 'constant.com',
          name: 'Constant',
          location: {},
          id: '5f72f6339413f842f17b4dfb',
          updatedAt: '2023-01-15T18:27:29.054Z',
        },
        position: 'Chief Executive Officer',
      },
    ],
    countryCode: 'US',
    location: 'United States',
    id: '5f76bfca4aee061e2fcb95ea',
    geolocation: {},
    saved: false,
    name: 'J J  Kardwell',
  },
  {
    lastName: 'Choi',
    notes: null,
    contactInfo: null,
    linkedinUrl: 'https://www.linkedin.com/in/realjhc/',
    lastUpdatedAt: '2023-01-15T18:27:36.203Z',
    postalCode: null,
    source: null,
    linkedin: [
      {
        id: 'realjhc',
        type: 'common',
      },
      {
        id: 'ACoAABHoRxYBWah21H_NJNKr1UIXXhmveIs2NHI',
        type: 'sales',
      },
    ],
    firstName: 'Jae',
    createdAt: '2019-08-13T21:04:56.000Z',
    companies: [
      {
        company: {
          keywords: [],
          companyType: 'private',
          lastUpdatedAt: '2023-01-15T18:27:36.203Z',
          postalCode: 'KY1-1104',
          companySiteData: {
            keywords: [],
          },
          description:
            'Pledgecamp is securing the future of crowdfunding\nwith blockchain protected investments.\n\nOur token sale begins February 18, 2019 for 30 days only. See more at https://pledgecamp.com',
          industry: 'Internet',
          linkedin: [
            {
              id: 'pledgecamp',
              type: 'common',
            },
            {
              id: '28640644',
              type: 'sales',
            },
          ],
          technologies: [
            '628defc8bdd46f5a39fd696e',
            '628defc8bdd46f5a39fd68be',
            '628defc8bdd46f5a39fd684a',
            '628defc8bdd46f5a39fd6397',
            '628defc8bdd46f5a39fd622e',
            '628defc8bdd46f5a39fd6218',
            '628defc8bdd46f5a39fd616c',
            '628defc8bdd46f5a39fd6097',
            '628defc8bdd46f5a39fd66aa',
            '628defc8bdd46f5a39fd6499',
            '628defc8bdd46f5a39fd6934',
          ],
          alternativeNames: [],
          createdAt: '2019-08-13T21:04:56.000Z',
          foundedAt: 2018,
          headquarters: 'S Church St, Cayman Islands George Town',
          competitors: [],
          size: 7,
          countryCode: 'KY',
          leads: 11,
          domain: 'pledgecamp.com',
          name: 'Pledgecamp',
          location: {},
          id: '5f7203e86e3f4d42e23e49a6',
          updatedAt: '2023-01-15T18:27:37.832Z',
        },
        position: 'CEO & Co-Founder',
      },
    ],
    countryCode: 'US',
    location: 'United States',
    id: '5f76bf734aee061e2fcb1351',
    geolocation: {},
    saved: false,
    name: 'Jae Choi',
  },
  {
    lastName: 'Mauskopf',
    notes: null,
    contactInfo: 'website: http://twitter.com/sm \n',
    linkedinUrl: 'https://www.linkedin.com/in/smausk/',
    lastUpdatedAt: '2023-01-07T00:56:01.896Z',
    postalCode: null,
    source: null,
    linkedin: [
      {
        id: 'smausk',
        type: 'common',
      },
      {
        id: 'ACoAAABYyZ8BMdBd8_Z5VYHz6HFtyaQ8l_Y8EFw',
        type: 'sales',
      },
    ],
    firstName: 'Sara',
    createdAt: '2019-11-07T12:13:00.000Z',
    companies: [
      {
        company: {
          totalVisits: 540300,
          keywords: [],
          companyType: 'private',
          lastUpdatedAt: '2023-01-07T00:56:01.896Z',
          postalCode: '94110',
          companySiteData: {
            keywords: [],
          },
          description:
            'Winnie is a marketplace for child care built on powerful data systems and backed by a trusted community of parents and providers. Parents use Winnie to discover high-quality local daycares and preschools and learn all about their programs including detailed descriptions, photos, tuition information, licensing status, availability data and more. Child care providers use Winnie to fill their open spaces, build their wait lists, and get support and resources to run their business efficiently.\n\nWinnie was started in early 2016 by tech veterans Sara Mauskopf and Anne Halsall. Working moms of two kids each, Sara and Anne became frustrated with the long search to find child care for their young children. Now Winnie is used throughout the United States and is helping connect millions of parents with high quality child care.',
          industry: 'Internet',
          linkedin: [
            {
              id: 'winnie',
              type: 'common',
            },
            {
              id: '7933038',
              type: 'sales',
            },
          ],
          technologies: [
            '628defc8bdd46f5a39fd5ebf',
            '628defc8bdd46f5a39fd64a5',
            '628defc8bdd46f5a39fd60af',
            '628defc8bdd46f5a39fd5e3b',
          ],
          alternativeNames: [
            'Aleene Logan Pre - School Center',
            "Angela's Family Day Care",
            'Becerra Family Childcare',
            'Sunset Sprouts Inc.',
            'Nurys family daycare',
            'Christ Lutheran Learning Center',
            'Little Angels',
            'New Day Care',
            'La Creche Daycare',
            'Winnie',
            'Winnie',
            'Winnie',
            'Winnie',
            'Winnie',
            'Winnie',
            'Winnie',
            'Winnie',
          ],
          createdAt: '2019-01-22T09:49:54.000Z',
          foundedAt: 2016,
          headquarters: '2811 Mission St California San Francisco',
          competitors: [
            {
              company: '5f720b749413f842f1730fcf',
              affinity: 98,
            },
            {
              company: '5f725a00502521426f869c4f',
              affinity: 98,
            },
            {
              company: '605cc4d76cf7700083ca5c08',
              affinity: 98,
            },
            {
              company: '608aa987a5059200dbc59edf',
              affinity: 98,
            },
            {
              company: '60acec778320bc00272fca3a',
              affinity: 98,
            },
            {
              company: '620eb6642368be0056633e9d',
              affinity: 98,
            },
            {
              company: '62224b80eebac2004cb05207',
              affinity: 98,
            },
            {
              company: '6230f1096ab33000124fd4af',
              affinity: 98,
            },
            {
              company: '623c3e94a5a70900200df192',
              affinity: 98,
            },
            {
              company: '62423185772be2004b8a142a',
              affinity: 98,
            },
            {
              company: '624ecdc6b4507c0075b72ecd',
              affinity: 98,
            },
            {
              company: '6284a5cc570ba10018f76da3',
              affinity: 98,
            },
            {
              company: '62dffcd7b7eb1d003dc3df60',
              affinity: 98,
            },
            {
              company: '62e014f093ba320011eb0ab6',
              affinity: 98,
            },
            {
              company: '62e01a31b520b10035643694',
              affinity: 98,
            },
            {
              company: '62e01a88cbce0e00472b57d9',
              affinity: 98,
            },
            {
              company: '62e04c025785d0005691fb99',
              affinity: 98,
            },
            {
              company: '62e10a69412d5e00112d0c61',
              affinity: 98,
            },
            {
              company: '62e1106c031f56002620e184',
              affinity: 98,
            },
            {
              company: '62e14a2b39e8db0036117d98',
              affinity: 98,
            },
            {
              company: '62e16fb5403aad01114b57c7',
              affinity: 98,
            },
            {
              company: '62e18b3be9208d004cf4c458',
              affinity: 98,
            },
            {
              company: '62e1a308dbc38801b9107641',
              affinity: 98,
            },
            {
              company: '62e1b3862e176201731936d4',
              affinity: 98,
            },
            {
              company: '62e1d1450fb2da013be22e84',
              affinity: 98,
            },
            {
              company: '62e2825c5785d00056953152',
              affinity: 98,
            },
            {
              company: '62e28efd9e974c010d648da9',
              affinity: 98,
            },
            {
              company: '62e2902723f55603770a2d49',
              affinity: 98,
            },
            {
              company: '62e294cb713dea011cc60684',
              affinity: 98,
            },
            {
              company: '62e2d78c9b19b302e251acce',
              affinity: 98,
            },
            {
              company: '62e320a03b4a5d03a18fee51',
              affinity: 98,
            },
            {
              company: '62e3b7ed28ce9c00f090c2bd',
              affinity: 98,
            },
            {
              company: '62e3bd6ee4a0640129e9b5c8',
              affinity: 98,
            },
            {
              company: '62e3e0968e0a8d019aff5bbf',
              affinity: 98,
            },
            {
              company: '62e693e828ce9c00f0923447',
              affinity: 98,
            },
            {
              company: '62e74a4bd89908041fe2269d',
              affinity: 98,
            },
            {
              company: '62e780107d918703e704c3b3',
              affinity: 98,
            },
            {
              company: '62e7ba50d5162501ff312b95',
              affinity: 98,
            },
            {
              company: '62e7f0be4ff57c01f6d11e3f',
              affinity: 98,
            },
            {
              company: '62e89b343cd922059b4e8c3d',
              affinity: 98,
            },
            {
              company: '62e8a7313cd922059b4eb94b',
              affinity: 98,
            },
            {
              company: '62e8aaf373dc5605b77dacc3',
              affinity: 98,
            },
            {
              company: '62e8aaf773dc5605b77dacfc',
              affinity: 98,
            },
            {
              company: '62e8dc8c4881a801e0c968ba',
              affinity: 98,
            },
            {
              company: '62e9284da47421060bac9ce7',
              affinity: 98,
            },
            {
              company: '62e9338b2ab7620627c2f8a5',
              affinity: 98,
            },
            {
              company: '62ea04507e401106a214a39b',
              affinity: 98,
            },
            {
              company: '62ea5478cd847c022a799ab7',
              affinity: 98,
            },
            {
              company: '62ea591d702fcd02a7f7bf5e',
              affinity: 98,
            },
            {
              company: '62ea6f990c5aab0411236204',
              affinity: 98,
            },
            {
              company: '62ea952fcd847c022a7a8698',
              affinity: 98,
            },
            {
              company: '62ea97a85e2e660315ab1d46',
              affinity: 98,
            },
            {
              company: '62eaab25124768032e62c64c',
              affinity: 98,
            },
            {
              company: '62eb987f6051c207aff30d81',
              affinity: 98,
            },
            {
              company: '62eba2e0cd19cf03694cd2d8',
              affinity: 98,
            },
            {
              company: '62ebcba5fb64ce038573c38e',
              affinity: 98,
            },
            {
              company: '62ebe69777a69003931b1a97',
              affinity: 98,
            },
            {
              company: '62ecfe978ca2a5084942a781',
              affinity: 98,
            },
            {
              company: '62ed4783f700df08f1eaf22e',
              affinity: 98,
            },
            {
              company: '62ee215a826a3808c484cd61',
              affinity: 98,
            },
            {
              company: '62ee8e64702fcd02a7fda57d',
              affinity: 98,
            },
            {
              company: '62ee9ca1bb7a2004d8331824',
              affinity: 98,
            },
            {
              company: '62ef7b64d9151f03d96d0d69',
              affinity: 98,
            },
            {
              company: '62ef9ee6702fcd02a7fdfc09',
              affinity: 98,
            },
            {
              company: '62efe48562a84e0411a3ceba',
              affinity: 98,
            },
            {
              company: '62f0ba6ce2da4f02dfd73b72',
              affinity: 98,
            },
            {
              company: '62f0e076fe08b600487b01e6',
              affinity: 98,
            },
            {
              company: '62f0fc02eef7f000197e373b',
              affinity: 98,
            },
            {
              company: '62f10d53432f9700202d46d5',
              affinity: 98,
            },
            {
              company: '62f25c7138909c0011c35fcf',
              affinity: 98,
            },
            {
              company: '62f2a8678e6dec00a0f0912f',
              affinity: 98,
            },
            {
              company: '62f2b1a65003f800345a3d03',
              affinity: 98,
            },
            {
              company: '62f2b60bde34dd0040b3ed0c',
              affinity: 98,
            },
            {
              company: '62f35cde7ea891004166c1ee',
              affinity: 98,
            },
            {
              company: '62f377816cdea4001f5aa732',
              affinity: 98,
            },
            {
              company: '62f37c0e85f0ab0029634725',
              affinity: 98,
            },
            {
              company: '62f3b6fa766da2002aab7fd5',
              affinity: 98,
            },
            {
              company: '62f4c425143da60035be7394',
              affinity: 98,
            },
            {
              company: '62f4eb5b65ba0a00aee31e2d',
              affinity: 98,
            },
            {
              company: '62f50bab1a2c470018b7cf94',
              affinity: 98,
            },
            {
              company: '62f52123832ffd0020bf2a94',
              affinity: 98,
            },
            {
              company: '62f524b34f2c0400265ab354',
              affinity: 98,
            },
            {
              company: '62f54c10e26ac800112b11e1',
              affinity: 98,
            },
            {
              company: '62f54e34003ae30011054090',
              affinity: 98,
            },
            {
              company: '62f551e10ee7060011c44aab',
              affinity: 98,
            },
            {
              company: '62f57cde0ee7060011c4f106',
              affinity: 98,
            },
            {
              company: '62f58cd2b43ca3001964bd61',
              affinity: 98,
            },
            {
              company: '62f63f89f32108002cc77f3c',
              affinity: 98,
            },
            {
              company: '62f66306f548cc0011d01276',
              affinity: 98,
            },
            {
              company: '62f67f21ea4093003d930ac2',
              affinity: 98,
            },
            {
              company: '62f68c8a7facf2004856b60c',
              affinity: 98,
            },
            {
              company: '62f925f2ff372c001f0df509',
              affinity: 98,
            },
            {
              company: '62f9eec1c8d780005766fe97',
              affinity: 98,
            },
            {
              company: '62fa4836bb251e0058d6c445',
              affinity: 98,
            },
            {
              company: '62fa7a1e08a0b0001a86473a',
              affinity: 98,
            },
            {
              company: '62fb444ca0e67a0018ec43f8',
              affinity: 98,
            },
            {
              company: '62fb5d2817e4c8001fee9297',
              affinity: 98,
            },
            {
              company: '62fb760e098560001a8e8a61',
              affinity: 98,
            },
            {
              company: '62fb88b35442a3001f583185',
              affinity: 98,
            },
            {
              company: '62fb8ec15442a3001f584670',
              affinity: 98,
            },
            {
              company: '62fba6a068fd090036fa6509',
              affinity: 98,
            },
            {
              company: '62fbb500e29a20003c75a24e',
              affinity: 98,
            },
            {
              company: '62fbbca0d4400000415a13f8',
              affinity: 98,
            },
            {
              company: '62fbd83d95d890002b854a06',
              affinity: 98,
            },
            {
              company: '62fc7777ddbb96002a478994',
              affinity: 98,
            },
            {
              company: '62fc871568fd090036fd3fd6',
              affinity: 98,
            },
            {
              company: '62fc906cec4c290035564d48',
              affinity: 98,
            },
            {
              company: '62fc9e7de29a20003c76b647',
              affinity: 98,
            },
            {
              company: '62fcc1c6caa7fa004baf7b36',
              affinity: 98,
            },
            {
              company: '62fce119ec4c29003557473b',
              affinity: 98,
            },
            {
              company: '62fcf96c6525e0001924c9f3',
              affinity: 98,
            },
            {
              company: '62fd0ae41cefa6004cdab73b',
              affinity: 98,
            },
            {
              company: '62fd154bcaa7fa004bb060f6',
              affinity: 98,
            },
            {
              company: '62fd171795d890002b88a1fd',
              affinity: 98,
            },
            {
              company: '62fd178a6525e00019256708',
              affinity: 98,
            },
            {
              company: '62fd3aa132ae7400a260cf80',
              affinity: 98,
            },
            {
              company: '62fd48b0a75d2b0018096ff2',
              affinity: 98,
            },
            {
              company: '62fd4ec36aa93f0094ddbc07',
              affinity: 98,
            },
            {
              company: '62fdc0aad76258001ff549b5',
              affinity: 98,
            },
            {
              company: '62fdc891598a72002c74d45b',
              affinity: 98,
            },
            {
              company: '62fe5596a75d2b00180ae912',
              affinity: 98,
            },
            {
              company: '62ff3948598a72002c799ccb',
              affinity: 98,
            },
            {
              company: '62ffa3ceb271d7002199c001',
              affinity: 98,
            },
            {
              company: '62ffcdf8b271d700219a1bf1',
              affinity: 98,
            },
            {
              company: '630079127e2f89008500e89c',
              affinity: 98,
            },
            {
              company: '63021e6c099d840052cde8f4',
              affinity: 98,
            },
            {
              company: '63027413caa7fa004bb4868f',
              affinity: 98,
            },
            {
              company: '63034cbadf321c005836d572',
              affinity: 98,
            },
            {
              company: '63040f41fa300d0052e67fea',
              affinity: 98,
            },
            {
              company: '63046982d86c80001f05cffc',
              affinity: 98,
            },
            {
              company: '63047e979e594d00118b2257',
              affinity: 98,
            },
            {
              company: '6304fbb8db8d85001805b747',
              affinity: 98,
            },
            {
              company: '63051d8dcde95e004893a0ac',
              affinity: 98,
            },
            {
              company: '63061acd11134d00183df365',
              affinity: 98,
            },
            {
              company: '63069c9b33bd28006d050f0c',
              affinity: 98,
            },
            {
              company: '630726e4285733002ba5462a',
              affinity: 98,
            },
            {
              company: '63076ea86ada4e003dc0fdeb',
              affinity: 98,
            },
            {
              company: '6307ac5c553a17002663162a',
              affinity: 98,
            },
            {
              company: '6307f76e33bd28006d095231',
              affinity: 98,
            },
            {
              company: '630875e0762bf30026550d69',
              affinity: 98,
            },
            {
              company: '6308b9cecf7190001909acd7',
              affinity: 98,
            },
            {
              company: '6308d14a3c2322003c22eb8b',
              affinity: 98,
            },
            {
              company: '63090a3cb66eb500180e3e5c',
              affinity: 98,
            },
            {
              company: '63091198b0a9850011860fb9',
              affinity: 98,
            },
            {
              company: '5f721ffddab6bb429c072f31',
              affinity: 74,
            },
            {
              company: '5f7203da5caf37425a6dc5ee',
              affinity: 68,
            },
            {
              company: '5f7203d2dab6bb429c04dcd1',
              affinity: 76,
            },
            {
              company: '5f7203575caf37425a6daafe',
              affinity: 77,
            },
            {
              company: '5f721dc79413f842f1745bc8',
              affinity: 85,
            },
            {
              company: '5f7204c15caf37425a6df7bd',
              affinity: 71,
            },
            {
              company: '63045c70bd39f4003290ba42',
              affinity: 71,
            },
            {
              company: '5f7208206e3f4d42e23ee223',
              affinity: 80,
            },
            {
              company: '5f720df0077515428b0ad507',
              affinity: 80,
            },
            {
              company: '5f72137e6e3f4d42e23fed3d',
              affinity: 80,
            },
            {
              company: '5f7222e29413f842f174a996',
              affinity: 80,
            },
            {
              company: '5f727fd46e3f4d42e2444778',
              affinity: 80,
            },
            {
              company: '62ea8fdad1ad690228cde423',
              affinity: 80,
            },
            {
              company: '62ec0650e1cda4081fdccc6e',
              affinity: 80,
            },
            {
              company: '62f0d122aa66b903cbee0ae6',
              affinity: 80,
            },
            {
              company: '62f10c9058670b0012feab91',
              affinity: 80,
            },
            {
              company: '62f393916feb0e0020eb8969',
              affinity: 80,
            },
            {
              company: '62f4b8c765ba0a00aee23286',
              affinity: 80,
            },
            {
              company: '6301040830ff970013d89d89',
              affinity: 80,
            },
            {
              company: '5f7204a19413f842f17260a3',
              affinity: 100,
            },
            {
              company: '62e07a96486300011fed57e4',
              affinity: 100,
            },
            {
              company: '62e281401b3e3e004b6b9450',
              affinity: 100,
            },
            {
              company: '62ece1fa7a12db08811be8a3',
              affinity: 100,
            },
            {
              company: '62f9d16e2da2ac0027e1ae32',
              affinity: 100,
            },
            {
              company: '63024d5f30ff970013d9ea54',
              affinity: 100,
            },
            {
              company: '630347c2b271d700219f6a25',
              affinity: 100,
            },
            {
              company: '6307c1ec3958a2001f596592',
              affinity: 100,
            },
          ],
          revenueRange: null,
          size: 49,
          countryCode: 'US',
          leads: 60,
          domain: 'winnie.com',
          name: 'Winnie',
          location: {},
          id: '5f7207ed1a4cce430306b2d4',
          updatedAt: '2023-01-07T00:56:02.732Z',
        },
        position: 'CEO & Co-founder',
      },
    ],
    countryCode: 'US',
    location: 'United States',
    id: '5f76c55a7c58001e1a0f92aa',
    geolocation: {},
    saved: false,
    name: 'Sara Mauskopf',
  },
];
